import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'

import { Observable } from 'rxjs'

import * as fromAuth from '../../reducers'
import * as fromBase from '../../../base/reducers'

import * as status from '../../../base/actions/status.actions'
import * as account from '../../actions/account'

import { CreateRequest } from '../../models/account'

import { ContainerBase } from '../../../core/base/container-base'

@Component({
  selector: 'app-create-account-container',
  templateUrl: './template.html'
})
export class CreateAccountContainer extends ContainerBase implements OnInit {
  creating$: Observable<boolean>
  error$: Observable<any>

  userAccountNeedsValidation: boolean

  constructor(
    private store: Store<fromAuth.State>
  ) {
    super()

    this.error$ = store.pipe(select(fromAuth.getCreateError), takeUntil(this.destroyed$))
    this.creating$ = store.pipe(select(fromAuth.isCreating), takeUntil(this.destroyed$))

    store.pipe(
      select(fromBase.getTenantSettings),
      takeUntil(this.destroyed$)
    ).subscribe((settings) => {
      this.userAccountNeedsValidation = settings.user_account_needs_validation
    })

    // remove header space
    this.store.dispatch(new status.SetHeader(false));
  }

  ngOnInit() {
    this.store.dispatch(new account.CreateClear())
  }

  submitCreation(event: CreateRequest) {
    this.store.dispatch(new account.Create(event))
  }
}
